<template>
  <div class="w-full xl:w-2/5 mb-2 px-2">
    <p class="mb-1"><label for="cc_number" class="form-label">Número de tarjeta *</label></p>
    <the-mask
      class="form-input"
      id="cc_number"
      mask="###################"
      maxlength="19"
      minlength="14"
      name="cc_number"
      placeholder="Sin guiones ni espacios"
      required
      type="text"
      @input="ccChanged" />

    <div class="mt-1 text-green-500 text-xs leading-tight" v-if="applicableBank != null">Tu tarjeta aplica para la promoción con {{ applicableBank }}.</div>
    <div class="mt-1 text-main text-xs leading-tight" v-if="invalidCardErrorShown">Tu tarjeta no aplica para el método de pago seleccionado. Se te hará un cargo completo.</div>
  </div>
</template>
<script>
import { globalEventBus } from '../../_globalEventBus';
import {debounce} from '@utilities/Debounce.js';
export default {
  name: 'checkout-cc',
  data() {
    return {
      methodId: null,
      invalidCardErrorShown: false,
      applicableBank: null,
    }
  },
  methods: {
    ccChanged: debounce(
      function (newVal) {
        if (newVal.length > 3) {
          globalEventBus.$emit('ccNumberUpdated', newVal);

          if (this.methodId == null) {
            return;
          }

          axios.post(
            '/carrito/validar-cc-metodo-pago',
            {
              cc: newVal,
              payment_method: this.methodId
            }
          )
          .then(response => {
            this.invalidCardErrorShown = !response.data.data.is_valid;

            if (this.invalidCardErrorShown) {
              this.applicableBank = null;
            }
          })
          .catch(error => {
            alert('Lo sentimos, ocurrió algo extraño y no pudimos validar tu tarjeta de crédito.');
          });
        }
      },
      400
    ),
  },
  mounted() {
    globalEventBus.$on('paymentMethodUpdated', method => {
      this.methodId = method.id;
    });

    globalEventBus.$on('ccAppliesBankPromo', bank => {
      this.applicableBank = bank;
      this.invalidCardErrorShown = false;
    });
  }
}
</script>